/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Boards from './Boards/index'
import Header from './Header/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content"
  
}) {
  return (<React.Fragment
>
<Header
  viewPath={`${viewPath}/Header`}
/>
<Boards
  viewPath={`${viewPath}/Boards`}
/>
{children}
</React.Fragment>)
}